import { combineReducers } from "redux";
import passwordResetReducer from "./account/passwordResetReducer";
import adminProfileBlockReducer from "./admin-profile/adminProfileBlockReducer";
import adminProfileReducer from "./admin-profile/adminProfileReducer";
import adminProfileUnblockReducer from "./admin-profile/adminProfileUnblockReducer";
import adsReducer from "./ads/adsReducer";
import allAdsReducer from "./ads/allAdsReducer";
import deleteAdReducer from "./ads/deleteAdReducer";
import categoryReducer from "./category/categoryReducer";
import singleCategoryReducer from "./category/singleCategoryReducer";
import companiesProfileBlockReducer from "./companies-profile/companiesProfileBlockReducer";
import companiesProfilePublishReducer from "./companies-profile/companiesProfilePublishReducer";
import companiesProfileReducer from "./companies-profile/companiesProfileReducer";
import companiesProfileSaloonChooseReducer from "./companies-profile/companiesProfileSaloonChooseReducer";
import companiesProfileUnblockReducer from "./companies-profile/companiesProfileUnblockReducer";
import companiesProfileUnpublishReducer from "./companies-profile/companiesProfileUnpublishReducer";
import companiesReducer from "./companies/companiesReducer";
import CompanyIdReducer from "./company/companyIdReducer";
import CompanyInfoReducer from "./company/companyInfoReducer";
import CompanyReviewReducer from "./company/companyReviewReducer";
import csrfReducer from "./csrf/csrfReducer";
import createEthicsReducer from "./ethics/createEthicsReducer";
import EthicsReducer from "./ethics/EthicsReducer";
import createActionReducer from "./expo/createActionReducer";
import createExpoReducer from "./expo/createExpoReducer";
import deletePanoramaReducer from "./expo/deletePanoramaReducer";
import panoramaReducer from "./expo/panoramaReducer";
import homeAnnouncementsDataReducer from "./homePage/announcements/homeAnnouncementsDataReducer";
import homeSingleAnnouncementReducer from "./homePage/announcements/homeSingleAnnouncementReducer";
import mostViewedReducer from "./homePage/companies/mostViewedReducer";
import newestReducer from "./homePage/companies/newestReducer";
import gallseryReducer from "./homePage/gallery/galleryReducer";
import homeContactDataReducer from "./homePage/homeContactDataReducer";
import homeNewsDataReducer from "./homePage/news/homeNewsDataReducer";
import homeSingleNewsDataReducer from "./homePage/news/homeSingleNewsDataReducer";
import { getUserReducer } from "./login/getUserReducer";
import loginReducer from "./login/loginReducer";
import createManagerMessageReducer from "./managerMessage/createManagerMessageReducer";
import deleteMessageReducer from "./managerMessage/deleteMessageReducer";
import getManagerMessageReducer from "./managerMessage/getManagerMessageReducer";
import getSentMessageReducer from "./managerMessage/getSentMessageReducer";
import getSingleManagerMessageReducer from "./managerMessage/getSingleManagerMessage";
import getSingleSentMessage from "./managerMessage/getSingleSentMessage";
import messagesReducer from "./messages/messagesReducer";
import createPrivacyPolicyReducer from "./privacyPolicy/createPrivacyPolicyReducer";
import privacyPolicyReducer from "./privacyPolicy/privacyPolicyReducer";
import editSingleProductReducer from "./product/editSingleProductReducer";
import homeProductReducer from "./product/getProductReducer";
import productReducer from "./product/productReducer";
import singleProductReducer from "./product/singleProductReducer";
import profileReducer from "./profile/profileReducer";
import cityReducer from "./province/cityReducer";
import provinceReducer from "./province/provinceReducer";
import companyNewReviewReducer from "./review/companyNewReviewReducer";
import getAllReviewsReducer from "./review/getAllReviewsReducer";
import deleteSaloonReducer from "./saloons/saloon";
import saloonDetailReducer from "./saloons/saloonDetailReducer";
import saloonsReducer from "./saloons/saloons";
import SingleSaloonReducer from "./saloons/single-saloon";
import footerLinksReducer from "./stats/footerLinksReducer";
import statsReducer from "./stats/statsReducer";
import adminSingleTicket from "./tickets/adminSingleTicket";
import companyAllTickets from "./tickets/companyAllTickets";
import getAllTickets from "./tickets/getAllTickets";
import allUserprofilesReducer from "./user-profile/allUserprofilesReducer";
import userProfileReducer from "./user-profile/userProfileReducer";

const reducers = combineReducers({
    csrf: csrfReducer,
    login: loginReducer,
    user: getUserReducer,
    province: provinceReducer,
    city: cityReducer,
    saloons: saloonsReducer,
    saloon: deleteSaloonReducer,
    singleSaloon: SingleSaloonReducer,
    contactData: homeContactDataReducer,
    messages: messagesReducer,
    category: categoryReducer,
    single_category: singleCategoryReducer,
    product: productReducer,
    single_product: singleProductReducer,
    edited_single_product: editSingleProductReducer,
    company_profile: profileReducer,
    home_product: homeProductReducer,
    companies_page: companiesReducer,
    newest_companies: newestReducer,
    most_viewed_companies: mostViewedReducer,
    manager_message: createManagerMessageReducer,
    get_manager_message: getManagerMessageReducer,
    single_manager_message: getSingleManagerMessageReducer,
    sent_messages: getSentMessageReducer,
    single_sent_message: getSingleSentMessage,
    deleteManagerMessage: deleteMessageReducer,

    newsData: homeNewsDataReducer,
    single_news: homeSingleNewsDataReducer,

    announcements_data: homeAnnouncementsDataReducer,
    single_announcement: homeSingleAnnouncementReducer,

    stats: statsReducer,
    footer_links: footerLinksReducer,
    gallery: gallseryReducer,
    privacy_info: privacyPolicyReducer,
    create_privacy: createPrivacyPolicyReducer,
    ethics_info: EthicsReducer,
    create_ethics: createEthicsReducer,

    all_users: adminProfileReducer,
    block_user: adminProfileBlockReducer,
    unblock_user: adminProfileUnblockReducer,

    all_companies: companiesProfileReducer,
    block_companies: companiesProfileBlockReducer,
    unblock_companies: companiesProfileUnblockReducer,
    publish_companies: companiesProfilePublishReducer,
    unpublish_companies: companiesProfileUnpublishReducer,
    companies_saloon: companiesProfileSaloonChooseReducer,


    user_profile: userProfileReducer,
    all_users_profile: allUserprofilesReducer,

    company_info: CompanyInfoReducer,
    company_id: CompanyIdReducer,
    company_review: CompanyReviewReducer,
    company_new_comment: companyNewReviewReducer,
    all_reviews: getAllReviewsReducer,

    password_reset: passwordResetReducer,

    get_all_tickets: getAllTickets,
    adminSingleTicket: adminSingleTicket,
    company_all_tickets: companyAllTickets,

    create_ad: adsReducer,
    all_ads: allAdsReducer,
    deleteAd: deleteAdReducer,

    createExpo: createExpoReducer,
    panorama: panoramaReducer,
    delete_panorama: deletePanoramaReducer,
    expo_action: createActionReducer,
    saloon_detail: saloonDetailReducer,
})

export default reducers;